import clsx from 'clsx'
import {Dispatch, FC, SetStateAction, useState} from 'react'
import {ProductEditModalForm} from '../../../../../product-management/products-list/product-edit-modal/ProductEditModalForm'
import {SelectProduct} from './selectProduct'
import {Product} from '../../../../../product-management/products-list/core/_models'
import './selectProduct.css'

type props = {
  productSelected: {
    productSelected: Product | undefined
    setProductSelected: Dispatch<SetStateAction<Product | undefined>>
  }
  invoiceDate: string
}

const StepProduct: FC<props> = ({productSelected, invoiceDate}) => {
  const [tab, setTab] = useState(0)
  const tabs = [
    {
      id: 0,
      icon: 'la-star',
      title: 'علاقه‌مندی‌ها',
      hint: 'انتخاب سریع',
    },
    {
      id: 1,
      icon: 'la-list-alt',
      title: 'کالا/خدمت شما',
      hint: 'جستجو و انتخاب',
    },
    {
      id: 2,
      icon: 'la-plus-circle',
      title: 'تعریف جدید',
      hint: 'ثبت و استفاده',
    },
  ]

  return (
    <>
      <div className='mp-product-picker-tabs' role='tablist' aria-label='انتخاب کالا/خدمت'>
        {tabs.map((item) => (
          <button
            key={item.id}
            type='button'
            className={clsx('mp-product-picker-tab', {active: tab == item.id})}
            onClick={() => {
              setTab(item.id)
            }}
          >
            <i className={clsx('las', item.icon)}></i>
            <span>
              <strong>{item.title}</strong>
              <small>{item.hint}</small>
            </span>
          </button>
        ))}
      </div>
      <div className='mp-product-picker-panel'>
        {tab == 0 && (
          <SelectProduct productSelected={productSelected} invoiceDate={invoiceDate} isFavorite />
        )}
        {tab == 1 && <SelectProduct productSelected={productSelected} invoiceDate={invoiceDate} />}
        {tab == 2 && (
          <ProductEditModalForm productSelected={productSelected} invoiceDate={invoiceDate} />
        )}
      </div>
    </>
  )
}

export {StepProduct}
